import React, { Component } from "react";
import Button from "../../Button/Button";
import Progress from "../Progress/Progress";
import BackNext from "../BackNext/BackNext";
import "./Form2.css";

class Form2 extends Component {
	// Initial signup form before onboarding
	render() {
		return (
			<div className="signup-form">
				<div className="signup-form-l container">
					<Progress
						onboardingStepBuyer={this.props.onboardingStepBuyer}
						onboardingFlowBuyer={this.props.onboardingFlowBuyer}
					/>
					<form onSubmit={e => this.props.nextOnboardingBuyer(e)}>

						<label><b>6. Description of your company's business</b></label>
						<label><b>Use as few words as possible [important]</b></label>
						<input type="text" placeholder="e.g. artificial intelligence for merger and acquisition" value={this.props.signUpParamsBuyer['business']} onChange={e => this.props.onChangeInput('business', e.target.value, 'signUpParamsBuyer')}/>

						<label>7. When was your company founded? [optional]</label>
						<input type="text" placeholder="e.g. 2017" value={this.props.signUpParamsBuyer['founded']} onChange={e => this.props.onChangeInput('founded', e.target.value, 'signUpParamsBuyer')}/>

						<label>8. Number of your employees [optional]</label>
						<input type="text" placeholder="e.g. 150" value={this.props.signUpParamsBuyer['employee_number']} onChange={e => this.props.onChangeInput('employee_number', e.target.value, 'signUpParamsBuyer')}/>
					
						<label>9. Number of your customers [optional]</label>
						<input type="text" placeholder="e.g. 200" value={this.props.signUpParamsBuyer['customer_number']} onChange={e => this.props.onChangeInput('customer_number', e.target.value, 'signUpParamsBuyer')}/>

						<label>10. Major industries of your customers [optional]</label>
						<label> Separate different industries with ";"</label>
						<input type="text" placeholder="e.g. investment banks; technology startup companies" value={this.props.signUpParamsBuyer['customer_industry']} onChange={e => this.props.onChangeInput('customer_industry', e.target.value, 'signUpParamsBuyer')}/>
		
						
						<BackNext
							nextOnboardingBuyer={this.props.nextOnboardingBuyer}
							backOnboardingBuyer={this.props.backOnboardingBuyer}
							back={true}
							next={this.props.onboardingStepBuyer === 3 ? false : true}
						/>
					</form>
				</div>

			</div>
				
		);
	}
}

export default Form2;


// WEBPACK FOOTER //
// ./src/components/BuyerList/Form2/Form2.js